import { AuthDomain } from 'auth-lib-front';

import Project = AuthDomain.Object.Project;

export const featureFlagQueryKeys = {
  detail: (projectId: Project.Id) => ['troppus', 'featureFlag', 'detail', projectId] as const,
};
